import React , {useState , useEffect} from 'react';
import Footer from '../components/Footer';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import Aos from 'aos';
import "aos/dist/aos.css";



const JoinUs = () => {

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


  const [showSlideMenu , setShowSlideMenu] = useState(false);
  
  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="main_homepage" >

    
    <NavbarHome />

    <div className="advertistments_heroarea mt-1" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
  


      <div className="single_advert_section" style={{   background: `linear-gradient(  rgba(0,0,0,0.4) , #010101 ) , url('/images/heroarea/2.jpg') center / cover `  }}  >

      <div className="content_heroarea">
        <img src="/images/icons/logo.png" alt="" className="heroarea_logo" />
        <h1 className="heroarea_headline">  البوصلة السياحية </h1>
        <h1 className="heroarea_subheadline">    الانضمام لفريقنا </h1>

        <button className="btn_category w-30 mt-1" onClick={() =>  window.scrollTo(750 , 750) } >    انضم الان </button>

      </div>
      </div>

  
    </div>

   



    <div className="section most_features_section container-mid">

<div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">  الانضمام لفريقنا </h1>
</div>

<div className="d-flex-c f-sv f-wrap features_icons section">

 <div className="single_join_us text-center" data-aos="fade-left" data-aos-delay="20" data-aos-easing="ease" data-aos-mirror="true" >
    <img src="/images/icons/user.png" alt="" className="join_avatar" />
    <div className="mt-1"></div>
    <h1 className="headline_feaure_info">افراد</h1>

    <button className=" btn_form" onClick={() => openInNewTab('https://docs.google.com/forms/d/e/1FAIpQLSebzQoJEyf2SJV3AiT2kA7xA5O6cAzzRsdGWSLepwxZ3C0jsw/viewform') } >ملئ النموذج</button>
 </div>

 <div className="single_join_us text-center" data-aos="fade-left" data-aos-delay="20" data-aos-easing="ease" data-aos-mirror="true" >
    <img src="/images/icons/group.png" alt="" className="join_avatar" />
    <div className="mt-1"></div>
    <h1 className="headline_feaure_info"> شركات </h1>
    <button className=" btn_form" onClick={() => openInNewTab('https://docs.google.com/forms/d/e/1FAIpQLSdDW14DVBTcS32YtEsI1t4NTDZu7vqdHC99q6lE58iMlJCiLQ/viewform') } >ملئ النموذج</button>
 </div>

</div>

</div>



   


    <Footer />
    </div>
  )
}

export default JoinUs